import { api } from "@/api/client";

export type Project = {
  id: string;
  number?: string;
  name: string;
  stage?: string;
  description?: string;
  status?: number;
  createdById?: string;
  creationDate?: Date;
};

export function getProjectList() {
  return api.get<Project[]>("projects");
}
